// Navigation
document.addEventListener("DOMContentLoaded", function () {
    const isDesktopDevice = function () {
        return window.matchMedia("(min-width: 1281px)").matches;
    };

    const mobileDevice = window.matchMedia("(max-width: 580px)");


    // if ($('form').length) {
    //     $('form').find('input.input.phone.text').on('input', function () {
    //         const value = $(this).val();
    //         const validPattern = /^[0-9+\-\s()]*$/;
    //
    //         if (validPattern.test(value)) {
    //             $(this).siblings('#phone-format-error').css('display', 'none');
    //         } else {
    //             const cleaned = value.replace(/[^0-9+\-\s()]/g, '');
    //             $(this).val(cleaned);
    //             $(this).siblings('#phone-format-error').css('display', 'unset');
    //         }
    //     });
    // }

    function handleMobileThreshold(e) {
        const actions = document.querySelector("ul.actions");
        const pages = document.querySelector("ul.pages");
        if (e.matches) {
            // move actions items to the right place for focus order
            actions.after(pages);
        } else {
            // move actions items back to their original place
            actions.before(pages);
        }
    }

    handleMobileThreshold(mobileDevice);
    mobileDevice.addEventListener("change", handleMobileThreshold);

    let timeoutNav;

    const closeSubNavItems = function () {
        document
            .querySelectorAll("nav ul.pages li")
            .forEach(function (closednavitem) {
                closednavitem.dataset.open = "false";
                // $(closednavitem).removeClass('clicked');
            });
    };
    document
        .querySelector("nav .burger")
        .addEventListener("click", function (e) {
            closeSubNavItems();

            const nav = e.target.closest("nav");
            if (nav) nav.dataset.open = "true";
            const close = document.querySelector("nav .close");
            if (close) close.focus();
        });
    document
        .querySelector("nav .close")
        .addEventListener("click", function (e) {
            const nav = e.target.closest("nav");
            nav.dataset.open = "false";
            nav.dataset.subnavopen = "false";
            const burger = document.querySelector("nav .burger");
            if (burger) burger.focus();
        });

    document.querySelectorAll("nav ul.pages > li").forEach(function (navitem) {
        navitem.addEventListener("mouseenter", function (e) {
            if (isDesktopDevice()) {
                closeSubNavItems();
                const navitem = e.currentTarget;
                if (navitem) navitem.dataset.open = "true";
                clearTimeout(timeoutNav);
            }
        });
    });
    document.querySelectorAll("nav ul.pages > li").forEach(function (navitem) {
        navitem.addEventListener("mouseleave", function (e) {
            if (isDesktopDevice()) {
                const navitem = e.currentTarget;
                if (navitem) timeoutNav = window.setTimeout(() => {
                    navitem.dataset.open = "false";
                }, 500);
            }
            clearTimeout(timeoutNav);
        })
        navitem.addEventListener("click", function (e) {
            if (isDesktopDevice()) {
                let clicked = e.target;
                if ($(clicked).hasClass('click-through')) {
                    location.href = '/' + $(clicked).data('target');
                } else {
                    let subnav = $(clicked).parent().find('div.subnav');
                    let firstChild = $(subnav).find('a').first()[0];
                    location.href = firstChild.href;
                }
                // if (e.target.closest('div.subnav')) return;
                // const navitem = e.currentTarget;
                // if (navitem) {
                //     const isOpen = $(navitem).hasClass('clicked');
                //     closeSubNavItems();
                //     if (!isOpen) {
                //         navitem.dataset.open = "true";
                //         $(navitem).addClass('clicked');
                //     } else {
                //         navitem.dataset.open = "false";
                //     }
                // }
                // clearTimeout(timeoutNav);
            }
        });
    });
    // document.querySelectorAll("nav ul.pages > li").forEach(function (navitem) {
    //     navitem.addEventListener("click", function (e) {
    //         if (isDesktopDevice()) {
    //             const navitem = e.currentTarget;
    //             if (navitem)
    //                 timeoutNav = window.setTimeout(() => {
    //                     navitem.dataset.open = "false";
    //                 }, 500);
    //         }
    //     });
    // });
    document.addEventListener("click", function (e) {
        // console.log(e.target);
        if (!e.target.closest("nav")) {
            closeSubNavItems();
            const nav = document.querySelector('nav');
            nav.dataset.open = "false";
            nav.dataset.subnavopen = "false";
        }
    });

    document
        .querySelectorAll("nav ul.pages > li button")
        .forEach((navbutton) => {
            navbutton.addEventListener("keyup", function (e) {
                if (isDesktopDevice()) {
                    if (e.shiftKey && e.code === "Tab") {
                        closeSubNavItems();
                        const navitem = e.target.closest("li");
                        if (navitem) navitem.dataset.open = "true";
                    } else if (e.code === "Tab") {
                        closeSubNavItems();
                        const navitem = e.target.closest("li");
                        if (navitem) navitem.dataset.open = "true";
                    } else if (e.code === "Escape") {
                        closeSubNavItems();
                    }
                }
            });

            // toggle nav on click
            navbutton.addEventListener("click", function (e) {
                if (isDesktopDevice()) {
                    const navitem = e.currentTarget.closest("li");
                    if (navitem.dataset.open === "true") {
                        navitem.dataset.open = "false";
                    } else {
                        navitem.dataset.open = "true";
                    }
                    clearTimeout(timeoutNav);
                }
            });
            navbutton.addEventListener("keydown", function (e) {
                if (!isDesktopDevice()) {
                    if (e.code === "Enter") {
                        const back = document.querySelector("nav .back");
                        if (back)
                            window.setTimeout(() => {
                                back.focus();
                            }, 50);
                    }
                }
            });
        });
    document
        .querySelectorAll("nav ul.pages > li li:last-of-type a")
        .forEach((navbutton) => {
            navbutton.addEventListener("keydown", function (e) {
                if (isDesktopDevice()) {
                    if (e.code === "Tab") {
                        closeSubNavItems();
                    }
                } else {
                    if (!e.shiftKey && e.code === "Tab") {
                        const back = document.querySelector("nav .back");
                        if (back)
                            window.setTimeout(() => {
                                back.focus();
                            }, 50);
                    }
                }
            });
        });

    document
        .querySelectorAll("nav ul.pages li:last-of-type button")
        .forEach(function (navitem) {
            navitem.addEventListener("keydown", function (e) {
                if (!isDesktopDevice()) {
                    if (e.code === "Tab") {
                        const close = document.querySelector("nav .close");
                        if (close)
                            window.setTimeout(() => {
                                close.focus();
                            }, 50);
                    }
                }
            });
        });

    document
        .querySelectorAll("nav ul.pages li li a")
        .forEach(function (subnavitem) {
            subnavitem.addEventListener("keydown", function (e) {
                if (e.code === "Escape" && isDesktopDevice()) {
                    const parentLink = e.target
                        .closest(".subnav")
                        .closest("li")
                        .querySelector("button");
                    if (parentLink) {
                        parentLink.focus();
                    }
                    closeSubNavItems();
                }
            });
        });
    document.querySelector("nav").addEventListener("keydown", function (e) {
        if (e.code === "Escape" && !isDesktopDevice()) {
            const nav = e.target.closest("nav");
            console.log(nav.dataset.subnavopen);
            if (nav.dataset.subnavopen === "true") {
                closeSubNavItems();
                nav.dataset.subnavopen = "false";
                const close = document.querySelector("nav .close");
                if (close) close.focus();
            } else {
                nav.dataset.open = "false";
                const burger = document.querySelector("nav .burger");
                if (burger)
                    window.setTimeout(() => {
                        burger.focus();
                    }, 50);
            }
        }
    });

    document
        .querySelectorAll("nav ul.pages button")
        .forEach(function (navitem) {
            navitem.addEventListener("click", function (e) {
                if (!isDesktopDevice()) {
                    closeSubNavItems();
                    const navitem = e.target.closest("li");
                    if (navitem) navitem.dataset.open = "true";
                    const nav = e.target.closest("nav");
                    if (nav) nav.dataset.subnavopen = "true";
                }
            });
        });
    document.querySelector("nav .back").addEventListener("click", function (e) {
        if (!isDesktopDevice()) {
            closeSubNavItems();
            const nav = e.target.closest("nav");
            if (nav) nav.dataset.subnavopen = "false";
            const close = document.querySelector("nav .close");
            if (close) close.focus();
        }
    });
    document
        .querySelector("nav .back")
        .addEventListener("keydown", function (e) {
            if (!isDesktopDevice()) {
                console.log(e.shiftKey, e.code === "Tab");
                if (e.shiftKey && e.code === "Tab") {
                    const lastsubnavitem = document.querySelector(
                        "nav ul.pages li[data-open='true'] li:last-of-type a",
                    );
                    window.setTimeout(() => {
                        lastsubnavitem.focus();
                    }, 50);
                }
            }
        });

    bindClickable();

    if ($('.alert.alert-banner').length) {
        watchAlert();
    }
});

const bindClickable = () => {
    document.querySelectorAll(".clickable").forEach((card) => {
        const link = card.querySelector("a");

        if (link) {
            card.addEventListener("click", () => {
                link.click();
            });
            card.classList.add("ready");
        }
    });
};

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function watchAlert() {
    const alertBars = document.querySelectorAll('.alert.alert-banner');

    alertBars.forEach(function (alertBar) {
        const closeBtn = alertBar.querySelector('.alert-close');

        if (closeBtn) {
            closeBtn.addEventListener('click', function () {
                alertBar.style.display = 'none';
                setCookie('alert-hidden-' + alertBar.dataset.alertKey, alertBar.dataset.alertCode, 1);
                document.querySelector('main').classList.add('alert-hidden');
                document.querySelector('#navigator').classList.add('alert-hidden');
            });
        }
    });
}
